import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import translationTR from './locales/tr/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  tr: {
    translation: translationTR
  },
  en: {
    translation: translationEN
  }
};

// Detect language based on IP geolocation
const detectLanguageFromIP = async () => {
  try {
    // Check if we already have a cached geolocation result
    const cachedGeoLang = localStorage.getItem('geoDetectedLang');
    if (cachedGeoLang) {
      return cachedGeoLang;
    }

    // Fetch user's country from IP
    console.log('Fetching IP geolocation...');
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();

    console.log('IP API Response:', data);
    console.log('Detected country code:', data.country_code);

    // If user is from Turkey, use Turkish; otherwise English
    const detectedLang = data.country_code === 'TR' ? 'tr' : 'en';

    // Cache the result
    localStorage.setItem('geoDetectedLang', detectedLang);

    console.log('Language set to:', detectedLang);

    return detectedLang;
  } catch (error) {
    console.log('Geolocation detection failed, falling back to browser language');
    return null;
  }
};

// Initialize language detection
const initializeLanguage = async () => {
  console.log('Initializing language detection...');

  // Check if user has MANUALLY selected a language (not auto-detected)
  const manualLanguageSelection = localStorage.getItem('userManualLanguage');
  console.log('Manual language selection:', manualLanguageSelection);

  if (manualLanguageSelection) {
    // User has manually selected a language, use it
    console.log('Using manual language preference:', manualLanguageSelection);
    return;
  }

  // No manual selection, detect from IP
  console.log('No manual selection, detecting from IP...');
  const detectedLang = await detectLanguageFromIP();

  if (detectedLang) {
    console.log('Changing language to:', detectedLang);
    i18n.changeLanguage(detectedLang);
  } else {
    console.log('IP detection failed, using fallback');
  }
};

i18n
  .use(initReactI18next) // React i18next'i başlat
  .init({
    resources,
    lng: 'en', // Başlangıç dili (IP tespiti hemen değiştirecek)
    fallbackLng: 'en', // Fallback dili
    debug: false,

    interpolation: {
      escapeValue: false // React zaten XSS koruması sağlıyor
    },

    // Otomatik detection'ı kapat, manuel kontrol edeceğiz
    react: {
      useSuspense: false
    }
  })
  .then(() => {
    // Run language detection after i18n is fully initialized
    initializeLanguage();
  });

export default i18n;
